import { gettext } from '@eventbrite/i18n';
import isString from 'lodash/isString';

const COUNTRY_CODE_TO_NAME = {
    AF: gettext('Afghanistan'),
    AX: gettext('Åland Islands'),
    AL: gettext('Albania'),
    DZ: gettext('Algeria'),
    AS: gettext('American Samoa'),
    AD: gettext('Andorra'),
    AO: gettext('Angola'),
    AI: gettext('Anguilla'),
    AQ: gettext('Antarctica'),
    AG: gettext('Antigua and Barbuda'),
    AR: gettext('Argentina'),
    AM: gettext('Armenia'),
    AW: gettext('Aruba'),
    AU: gettext('Australia'),
    AT: gettext('Austria'),
    AZ: gettext('Azerbaijan'),
    BS: gettext('Bahamas'),
    BH: gettext('Bahrain'),
    BD: gettext('Bangladesh'),
    BB: gettext('Barbados'),
    BY: gettext('Belarus'),
    BE: gettext('Belgium'),
    BZ: gettext('Belize'),
    BJ: gettext('Benin'),
    BM: gettext('Bermuda'),
    BT: gettext('Bhutan'),
    BO: gettext('Bolivia'),
    BQ: gettext('Bonaire, Sint Eustatius and Saba'),
    BA: gettext('Bosnia and Herzegovina'),
    BW: gettext('Botswana'),
    BV: gettext('Bouvet Island'),
    BR: gettext('Brazil'),
    IO: gettext('British Indian Ocean Territory'),
    BN: gettext('Brunei Darussalam'),
    BG: gettext('Bulgaria'),
    BF: gettext('Burkina Faso'),
    BI: gettext('Burundi'),
    KH: gettext('Cambodia'),
    CM: gettext('Cameroon'),
    CA: gettext('Canada'),
    CV: gettext('Cape Verde'),
    KY: gettext('Cayman Islands'),
    CF: gettext('Central African Republic'),
    TD: gettext('Chad'),
    CL: gettext('Chile'),
    CN: gettext('China'),
    CX: gettext('Christmas Island'),
    CC: gettext('Cocos  Islands'),
    CO: gettext('Colombia'),
    KM: gettext('Comoros'),
    CG: gettext('Congo'),
    CD: gettext('Congo, The Democratic Republic Of The'),
    CK: gettext('Cook Islands'),
    CR: gettext('Costa Rica'),
    CI: gettext("Côte D'Ivoire"),
    HR: gettext('Croatia'),
    CU: gettext('Cuba'),
    CW: gettext('Curaçao'),
    CY: gettext('Cyprus'),
    CZ: gettext('Czech Republic'),
    DK: gettext('Denmark'),
    DJ: gettext('Djibouti'),
    DM: gettext('Dominica'),
    DO: gettext('Dominican Republic'),
    EC: gettext('Ecuador'),
    EG: gettext('Egypt'),
    SV: gettext('El Salvador'),
    GQ: gettext('Equatorial Guinea'),
    ER: gettext('Eritrea'),
    EE: gettext('Estonia'),
    ET: gettext('Ethiopia'),
    FK: gettext('Falkland Islands'),
    FO: gettext('Faroe Islands'),
    FJ: gettext('Fiji'),
    FI: gettext('Finland'),
    FR: gettext('France'),
    GF: gettext('French Guiana'),
    PF: gettext('French Polynesia'),
    TF: gettext('French Southern Territories'),
    GA: gettext('Gabon'),
    GM: gettext('Gambia'),
    GE: gettext('Georgia'),
    DE: gettext('Germany'),
    GH: gettext('Ghana'),
    GI: gettext('Gibraltar'),
    GR: gettext('Greece'),
    GL: gettext('Greenland'),
    GD: gettext('Grenada'),
    GP: gettext('Guadeloupe'),
    GU: gettext('Guam'),
    GT: gettext('Guatemala'),
    GG: gettext('Guernsey'),
    GW: gettext('Guinea-Bissau'),
    GN: gettext('Guinea'),
    GY: gettext('Guyana'),
    HT: gettext('Haiti'),
    HM: gettext('Heard & McDonald Islands'),
    HN: gettext('Honduras'),
    HK: gettext('Hong Kong'),
    HU: gettext('Hungary'),
    IS: gettext('Iceland'),
    IN: gettext('India'),
    ID: gettext('Indonesia'),
    IR: gettext('Iran'),
    IQ: gettext('Iraq'),
    IE: gettext('Ireland'),
    IM: gettext('Isle of Man'),
    IL: gettext('Israel'),
    IT: gettext('Italy'),
    JM: gettext('Jamaica'),
    JP: gettext('Japan'),
    JE: gettext('Jersey'),
    JO: gettext('Jordan'),
    KZ: gettext('Kazakhstan'),
    KE: gettext('Kenya'),
    KI: gettext('Kiribati'),
    KP: gettext("Korea, Democratic People's Republic Of"),
    KR: gettext('Korea, Republic of'),
    KW: gettext('Kuwait'),
    KG: gettext('Kyrgyzstan'),
    LA: gettext('Laos'),
    LV: gettext('Latvia'),
    LB: gettext('Lebanon'),
    LS: gettext('Lesotho'),
    LR: gettext('Liberia'),
    LY: gettext('Libya'),
    LI: gettext('Liechtenstein'),
    LT: gettext('Lithuania'),
    LU: gettext('Luxembourg'),
    MO: gettext('Macau'),
    MK: gettext('Macedonia, the Former Yugoslav Republic Of'),
    MG: gettext('Madagascar'),
    MW: gettext('Malawi'),
    MY: gettext('Malaysia'),
    MV: gettext('Maldives'),
    ML: gettext('Mali'),
    MT: gettext('Malta'),
    MH: gettext('Marshall Islands'),
    MQ: gettext('Martinique'),
    MR: gettext('Mauritania'),
    MU: gettext('Mauritius'),
    YT: gettext('Mayotte'),
    MX: gettext('Mexico'),
    FM: gettext('Micronesia, Federated States Of'),
    MD: gettext('Moldova'),
    MC: gettext('Monaco'),
    MN: gettext('Mongolia'),
    ME: gettext('Montenegro'),
    MS: gettext('Montserrat'),
    MA: gettext('Morocco'),
    MZ: gettext('Mozambique'),
    MM: gettext('Myanmar'),
    NA: gettext('Namibia'),
    NR: gettext('Nauru'),
    NP: gettext('Nepal'),
    NL: gettext('Netherlands'),
    NC: gettext('New Caledonia'),
    NZ: gettext('New Zealand'),
    NI: gettext('Nicaragua'),
    NG: gettext('Nigeria'),
    NE: gettext('Niger'),
    NU: gettext('Niue'),
    NF: gettext('Norfolk Island'),
    MP: gettext('Northern Mariana Islands'),
    NO: gettext('Norway'),
    OM: gettext('Oman'),
    PK: gettext('Pakistan'),
    PW: gettext('Palau'),
    PS: gettext('Palestine'),
    PA: gettext('Panama'),
    PG: gettext('Papua New Guinea'),
    PY: gettext('Paraguay'),
    PE: gettext('Peru'),
    PH: gettext('Philippines'),
    PN: gettext('Pitcairn'),
    PL: gettext('Poland'),
    PT: gettext('Portugal'),
    PR: gettext('Puerto Rico'),
    QA: gettext('Qatar'),
    RE: gettext('Reunion'),
    RO: gettext('Romania'),
    RU: gettext('Russia'),
    RW: gettext('Rwanda'),
    SH: gettext('Saint Helena, Ascension and Tristan Da Cunha'),
    KN: gettext('Saint Kitts And Nevis'),
    LC: gettext('Saint Lucia'),
    VC: gettext('Saint Vincent And The Grenadines'),
    WS: gettext('Samoa'),
    SM: gettext('San Marino'),
    ST: gettext('Sao Tome and Principe'),
    SA: gettext('Saudi Arabia'),
    SN: gettext('Senegal'),
    RS: gettext('Serbia'),
    SC: gettext('Seychelles'),
    GS: gettext('S.Georgia & S.Sandwich Islands'),
    SL: gettext('Sierra Leone'),
    SG: gettext('Singapore'),
    SK: gettext('Slovakia'),
    SI: gettext('Slovenia'),
    SB: gettext('Solomon Islands'),
    SO: gettext('Somalia'),
    ZA: gettext('South Africa'),
    SS: gettext('South Sudan'),
    ES: gettext('Spain'),
    LK: gettext('Sri Lanka'),
    BL: gettext('St. Barthélemy'),
    SX: gettext('St. Maarten'),
    MF: gettext('St. Martin'),
    PM: gettext('St. Pierre & Miquelon'),
    SD: gettext('Sudan'),
    SR: gettext('Suriname'),
    SJ: gettext('Svalbard & Jan Mayen Islands'),
    SZ: gettext('Swaziland'),
    SE: gettext('Sweden'),
    CH: gettext('Switzerland'),
    SY: gettext('Syria'),
    TW: gettext('Taiwan'),
    TJ: gettext('Tajikistan'),
    TZ: gettext('Tanzania'),
    TH: gettext('Thailand'),
    TL: gettext('East Timor'),
    TG: gettext('Togo'),
    TK: gettext('Tokelau'),
    TO: gettext('Tonga'),
    TT: gettext('Trinidad and Tobago'),
    TN: gettext('Tunisia'),
    TR: gettext('Turkey'),
    TM: gettext('Turkmenistan'),
    TC: gettext('Turks & Caicos Islands'),
    TV: gettext('Tuvalu'),
    UG: gettext('Uganda'),
    UA: gettext('Ukraine'),
    AE: gettext('United Arab Emirates'),
    GB: gettext('United Kingdom'),
    UM: gettext('United States Minor Outlying Islands'),
    US: gettext('United States'),
    UY: gettext('Uruguay'),
    UZ: gettext('Uzbekistan'),
    VU: gettext('Vanuatu'),
    VA: gettext('Vatican City'),
    VE: gettext('Venezuela'),
    VN: gettext('Viet Nam'),
    VG: gettext('Virgin Islands'),
    VI: gettext('Virgin Islands'),
    WF: gettext('Wallis & Futuna Islands'),
    EH: gettext('Western Sahara'),
    YE: gettext('Yemen'),
    ZM: gettext('Zambia'),
    ZW: gettext('Zimbabwe'),
};

const COUNTRIES_REQUIRING_REGION = {
    US: true,
    CA: true,
    IE: true,
    AU: true,
    BR: true,
};

/**
 * @typedef {{code: string, label: string, zip_required: boolean}} CountryInfo
 */

/**
 * Find a country object by country code in the country array in the format
 * returned by `fetchCountries` in ./api. For our purposes, all that matters is
 * that it's an array of objects with a `code` key that specifies the country
 * code.
 *
 * @param {CountryInfo[]} countries
 * @param {string} countryCode
 * @returns {CountryInfo}
 */
const _findCountryInCountries = (countries = [], countryCode) =>
    countries.find(({ code }) => code === countryCode);

/**
 * Returns whether region is a required field for this country.
 * @param {string} countryCode The country code (i.e. 'US', 'CA', etc)
 * @returns {boolean} Whether or not a region is required for the country
 */
export const isRegionRequired = (countryCode) =>
    !!COUNTRIES_REQUIRING_REGION[countryCode];

/**
 * Returns whether postal code is required for this country. Takes an array of
 * country objects as returned by the API like so:
 *
 * [{code: 'US', zip_required: true}, ...]
 * @param {CountryInfo[]} countries List of countries
 * @param {string} countryCode Country code to test
 * @returns {boolean} Whether or not a postal code is required for the country
 */
export const isPostalRequired = (countries, countryCode) => {
    const countryObj = _findCountryInCountries(countries, countryCode);

    return !!(countryObj && countryObj['zip_required']);
};

/**
 * Retrieves the country name for a given country code. If a match cannot
 * be found, just return the country code.
 *
 * @param  {string} [twoLetterCode='US'] Country code ("US", "CA")
 * @return {string} Localized Country Name
 */
export const getCountryNameFromTwoLetterCode = (twoLetterCode = 'US') => {
    // Fallback to country code.
    let countryName = twoLetterCode;
    const uppercaseCode = twoLetterCode.toUpperCase();

    if (COUNTRY_CODE_TO_NAME[uppercaseCode]) {
        countryName = COUNTRY_CODE_TO_NAME[uppercaseCode];
    }

    return countryName;
};

/**
 * Returns whether Boost tools are supported or not
 * for that specific locale
 *
 * @param  {string} locale e.g. en_US
 * @return {boolean} True if it's supported, false otherwise
 */
export const isBoostSupported = (locale) => {
    if (!locale || !isString(locale)) {
        return false;
    }

    return locale.toLowerCase().startsWith('en');
};
